import React, { useCallback, useEffect, useState } from 'react';
import {
  ConfirmationTypes,
  preRequest,
  requestBooking,
  resetPreRequest,
  selectPreRequest,
} from '@pharmaplan/common';
import { useAppSelector } from './useAppSelector';
import strings from '../localization';
import { useAppDispatch } from './useAppDispatch';
import { resetDialog, setDialog } from '../reducers/dialogReducer';
import ConfirmationModal from '../components/Modals/ConfirmationModal/ConfirmationModal';
import SoftwareWarning from '../components/SelfService/ServiceWorkshiftDetails/SoftwareWarning/SoftwareWarning';

const usePreRequest = () => {
  const dispatch = useAppDispatch();

  const [params, setParams] = useState({ id: '', isAutoSyncRecord: false });
  const { id, isAutoSyncRecord } = params ?? {};

  const preRequestStatus = useAppSelector(selectPreRequest);
  const { isSufficientSoftwareKnowledge, softwareLevel, name } = preRequestStatus ?? {};

  const softwarePercentage = (softwareLevel - 1) * 25;
  const softwareWarningMsg = strings.formatString(
    strings.softwareWarning,
    name,
    `${softwarePercentage}`,
  );

  const successAction = () => {
    dispatch(requestBooking({ workshiftid: id, isAutoSyncRecord }));
    dispatch(resetDialog());
  };

  const showSoftwareWarning = () => {
    dispatch(
      setDialog({
        heading: {
          title: '',
        },
        Component: (
          <ConfirmationModal
            type={ConfirmationTypes.softwareWarning}
            customMessage={<SoftwareWarning message={softwareWarningMsg} />}
            showCloseButton
            confirmAction={successAction}
          />
        ),
        showCloseButton: false,
      }),
    );
  };

  const runSoftwareCheck = useCallback(() => {
    if (id) {
      if (isSufficientSoftwareKnowledge === false) {
        showSoftwareWarning();
      } else if (isSufficientSoftwareKnowledge === true) {
        dispatch(requestBooking({ workshiftid: id, isAutoSyncRecord }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSufficientSoftwareKnowledge]);

  useEffect(() => {
    runSoftwareCheck();
    dispatch(resetPreRequest());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSufficientSoftwareKnowledge]);

  const preRequestBooking = (
    workshiftId: string,
    _isAutoSyncRecord?: boolean,
  ) => {
    setParams({ id: workshiftId, isAutoSyncRecord: !!_isAutoSyncRecord });
    dispatch(
      preRequest({
        workshiftid: workshiftId,
        isAutoSyncRecord: _isAutoSyncRecord,
      }),
    );
  };

  return { preRequestBooking };
};

export default usePreRequest;
